var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.88906L11.8891 3L13 4.11094L9.11094 8L13 11.8891L11.8891 13L8 9.11094L4.11094 13L3 11.8891L6.88906 8L3 4.11094L4.11094 3L8 6.88906Z",
    fill: "#C4C7C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSmall);
export default __webpack_public_path__ + "static/media/icon-close-small.01c303d4210701ab63ffe7b28a934348.svg";
export { ForwardRef as ReactComponent };